import React, { useMemo, useState } from "react";
import { Download, Search, Calendar, FileText, Filter, ChevronDown, RefreshCw, Shield } from "lucide-react";
import { useSelector } from "react-redux";
import "../MesrequetesStyles/BulletinsPaie.css";
import { API_BASE_URL } from "../../../../../api";

export default function BulletinsPaie() {
    const user = useSelector((state) => state.auth.user);

    const [searchMonth, setSearchMonth] = useState("");
    const [searchYear, setSearchYear] = useState("");
    const [showFilters, setShowFilters] = useState(true);

    // Données d'exemple des bulletins de paie
    const bulletins = useMemo(
        () => [
            { id: 1, month: "Octobre", year: 2025, date: "31/10/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 2, month: "Septembre", year: 2025, date: "30/09/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 3, month: "Août", year: 2025, date: "31/08/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 4, month: "Juillet", year: 2025, date: "31/07/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 5, month: "Juin", year: 2025, date: "30/06/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 6, month: "Mai", year: 2025, date: "31/05/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 7, month: "Avril", year: 2025, date: "30/04/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 8, month: "Mars", year: 2025, date: "31/03/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 9, month: "Février", year: 2025, date: "28/02/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 10, month: "Janvier", year: 2025, date: "31/01/2025", montant: "3450.00 dhs", status: "Disponible" },
            { id: 11, month: "Décembre", year: 2024, date: "31/12/2024", montant: "3350.00 dhs", status: "Disponible" },
            { id: 12, month: "Novembre", year: 2024, date: "30/11/2024", montant: "3350.00 dhs", status: "Disponible" },
        ],
        []
    );

    const mois = useMemo(
        () => ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        []
    );

    const annees = useMemo(() => {
        return [...new Set(bulletins.map((b) => b.year))].sort((a, b) => b - a);
    }, [bulletins]);

    const bulletinsFiltres = useMemo(() => {
        return bulletins.filter((b) => {
            const matchMonth = !searchMonth || b.month === searchMonth;
            const matchYear = !searchYear || b.year.toString() === searchYear;
            return matchMonth && matchYear;
        });
    }, [bulletins, searchMonth, searchYear]);

    const resetFilters = () => {
        setSearchMonth("");
        setSearchYear("");
    };

    const handleDownload = (bulletin) => {
        try {
            if (!user?.id) {
                alert("Utilisateur non connecté");
                return;
            }

            const downloadUrl =
                `${API_BASE_URL}/api/users/bulletins-paie/download?` +
                `mois=${encodeURIComponent(bulletin.month)}&` +
                `annee=${encodeURIComponent(bulletin.year)}&` +
                `montant=${encodeURIComponent(bulletin.montant.replace(" dhs", ""))}&` +
                `uid=${encodeURIComponent(user.id)}`;

            window.open(downloadUrl, "_blank");
        } catch (error) {
            console.error("Erreur:", error);
            alert("Erreur lors du téléchargement du bulletin");
        }
    };

    return (
        <div className="bpPage">
            <div className="bpWrap">
                {/* Header */}
                <div className="bpHeader">
                    <div className="bpHeadLeft">
                        <div className="bpHeadIcon">
                            <FileText size={18}/>
                        </div>
                        <div>
                            <h1>Mes bulletins de paie</h1>
                            <p>Consultez et téléchargez vos bulletins</p>
                        </div>
                    </div>

                    <div className="bpHeadRight">
                        <div className="bpTotalBox">
                            <div className="bpTotalLabel">Total</div>
                            <div className="bpTotalVal">{bulletinsFiltres.length}</div>
                        </div>
                    </div>
                </div>

                {/* ✅ NEW: Password info (no CSS change, inline only) */}
                {/*<div*/}
                {/*    style={{*/}
                {/*        marginBottom: 12,*/}
                {/*        padding: "10px 12px",*/}
                {/*        borderRadius: 10,*/}
                {/*        border: "1px solid rgba(0,0,0,0.08)",*/}
                {/*        background: "rgba(0,0,0,0.02)",*/}
                {/*        display: "flex",*/}
                {/*        alignItems: "center",*/}
                {/*        gap: 10,*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <Shield size={18} />*/}
                {/*    <div style={{ lineHeight: 1.3 }}>*/}
                {/*        <div style={{ fontWeight: 600 }}>PDF protégé par mot de passe</div>*/}
                {/*        <div style={{ fontSize: 13, opacity: 0.85 }}>*/}
                {/*            Mot de passe : <b>votre matricule</b> (ou la règle définie par votre entreprise).*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/* Filters card */}
                <div className="bpCard">
                    <div className="bpControls">
                        <div className="bpSearch">
                            <Search size={16}/>
                            <input
                                value={searchMonth || searchYear ? `Filtré : ${searchMonth || "Tous mois"} • ${searchYear || "Toutes années"}` : ""}
                                placeholder="Choisissez un mois et une année..."
                                readOnly
                            />
                        </div>

                        <button type="button" className="bpFilterBtn" onClick={() => setShowFilters((v) => !v)}>
                            <Filter size={18}/>
                            Filtres
                            <ChevronDown size={16} className={`bpChevron ${showFilters ? "is-open" : ""}`}/>
                        </button>
                    </div>

                    {showFilters && (
                        <div className="bpFilters">
                            <div className="bpField">
                                <label>Mois</label>
                                <div className="bpSelectWrap">
                                    <Calendar size={16}/>
                                    <select value={searchMonth} onChange={(e) => setSearchMonth(e.target.value)}>
                                        <option value="">Tous les mois</option>
                                        {mois.map((m) => (
                                            <option key={m} value={m}>
                                                {m}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="bpField">
                                <label>Année</label>
                                <div className="bpSelectWrap">
                                    <Calendar size={16}/>
                                    <select value={searchYear} onChange={(e) => setSearchYear(e.target.value)}>
                                        <option value="">Toutes les années</option>
                                        {annees.map((a) => (
                                            <option key={a} value={a}>
                                                {a}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="bpField bpField--actions">
                                <label>&nbsp;</label>
                                <button type="button" className="bpResetBtn" onClick={resetFilters}>
                                    <RefreshCw size={16}/>
                                    Réinitialiser
                                </button>
                            </div>
                        </div>
                    )}

                    {(searchMonth || searchYear) && (
                        <div className="bpActiveFilters">
                            <span className="bpActiveLabel">Filtres actifs:</span>
                            {searchMonth && <span className="bpTag">{searchMonth}</span>}
                            {searchYear && <span className="bpTag">{searchYear}</span>}
                        </div>
                    )}
                </div>

                {/* List */}
                {/*<div className="bpCard bpCard--noPad">*/}
                {/*    <div className="bpListHeader">*/}
                {/*        <div className="bpListHeaderTitle">*/}
                {/*            <FileText size={18} />*/}
                {/*            Liste des Bulletins de Paie*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*    {bulletinsFiltres.length === 0 ? (*/}
                {/*        <div className="bpEmpty">*/}
                {/*            <Search size={38} />*/}
                {/*            <p>Aucun bulletin trouvé pour ces critères</p>*/}
                {/*            <button type="button" className="bpLinkBtn" onClick={resetFilters}>*/}
                {/*                Réinitialiser les filtres*/}
                {/*            </button>*/}
                {/*        </div>*/}
                {/*    ) : (*/}
                {/*        <div className="bpList">*/}
                {/*            {bulletinsFiltres.map((b) => (*/}
                {/*                <div key={b.id} className="bpRow">*/}
                {/*                    <div className="bpRowLeft">*/}
                {/*                        <div className="bpRowIcon">*/}
                {/*                            <FileText size={18} />*/}
                {/*                        </div>*/}

                {/*                        <div className="bpRowInfo">*/}
                {/*                            <div className="bpRowTitle">*/}
                {/*                                Bulletin de {b.month} {b.year}*/}
                {/*                            </div>*/}

                {/*                            <div className="bpRowMeta">*/}
                {/*        <span className="bpMetaItem">*/}
                {/*          <Calendar size={14} />*/}
                {/*            {b.date}*/}
                {/*        </span>*/}

                {/*                                <span className="bpBadge">{b.status}</span>*/}
                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}

                {/*                    <div className="bpRowRight">*/}
                {/*                        <button type="button" className="bpDownloadBtn" onClick={() => handleDownload(b)}>*/}
                {/*                            <Download size={16} />*/}
                {/*                            Télécharger*/}
                {/*                        </button>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            ))}*/}
                {/*        </div>*/}
                {/*    )}*/}
                {/*</div>*/}

                <div className="bpCard bpCard--noPad">
                    <div className="bpListHeader">
                        <div className="bpListHeaderTitle">
                            <FileText size={18}/>
                            Liste des bulletins de paie
                        </div>
                    </div>

                    <div className="bpEmpty">
                        <FileText size={38}/>
                        <p>Aucun bulletin de paie disponible</p>
                    </div>
                </div>
                {/* Footer tip */}
                {/*<div className="bpTip">*/}
                {/*    <span className="bpTipStrong">💡 Astuce:</span> Vos bulletins de paie sont archivés de manière*/}
                {/*    sécurisée. Vous pouvez les télécharger à tout moment en format PDF.*/}
                {/*</div>*/}
            </div>
        </div>
    );
}
